export default {
    _private: {
        logout: "Sign out",
        title: {
            home: "Home",
            systemSet: "System setup",
            userManage: "User manage",
            roleManage: "Role manage",
            departmentManage: "Department manage",
            tms: "TMS",
            carrierManage: "Carrier manage",
            tableColumnSet: "Set table column",
            hiddenColumn: "Hidden column",
            displayColumn: "Display column",
            addUser: "Add user",
            editUser: "Edit user",
            terminalManage: "Terminal manage",
            addCarrier: "Add carrier",
            editCarrier: "Edit carrier",
            vehicleManage: "Vehicle manage"
        },
        button: {
            search: "Search",
            reset: "Reset",
            operate: "Operate",
            edit: "Edit",
            confirm: "Confirm",
            cancel: "Cancel",
            submit: "Submit",
            return: "Return",
            detail: "Detail"
        },
        label: {
            userName: "User name",
            userCode: "User code",
            department: "Department",
            role: "Role",
            password: "Password",
            confirmPassword: "Confirm Password",
            phone: "Phone",
            telephone: "Telephone",
            email: "Email",
            address: "Address",
            remark: "Remark",
            contract: "Contract",
            contractTel: "ContractTel",
            commids: "Commids",
            terminalName: "TerminalName",
            terminalNo: "TerminalNo",
            terminalTypeText: "TerminalTypeText",
            bindingObjectText: "BindingObjectText",
            bindingNo: "BindingNo",
            simNo: "SimNo",
            orgName: "OrgName",
            supplierName: "SupplierName",
            specification: "Specification",
            productionDate: "ProductionDate",
            installDate: "InstallDate",
            onlineStatus: "onlineStatus",
            terminalStatus: "terminalStatus"

        },
        placeholder: {
            userName: "User name",
            userCode: "User code",
            department: "Department",
            role: "Role",
            password: "Password",
            confirmPassword: "Confirm password",
            phone: "Phone",
            telephone: "Telephone",
            email: "Email",
            address: "Address",
            remark: "Remark",
            terminalNo: "TerminalNo",
            terminalName: "TerminalName",
            terminalTypeText: "TerminalTypeText",
            bindingObjectText: "BingingObjectText",
            contract: "Contract",
            contractTel: "ContractTel",
            commids: "Commids",
            vehicleList: "Select vehicle",
            vehicleTypeGb: "Vehicle type",
            vehicleType: "Freight type",
            vehicleBrand: "Vehicle brand",
            mainDriverId: "Select mainDriverId",
            assistantDriverId: "Select assistantDriverId",
            vehicleNo: "vehicleNo"
        },
        rule: {
            userName: "Please input user name",
            userCode: "Please input user login name",
            department: "Please select department",
            role: "Please input role",
            password: "Please input role",
            confirmPassword: "Please confirm the password again",
            phone: "Please input phone",
            telephone: "Please input telephone",
            email: "Please input email",
            address: "Please input address",
            vehicleNo: "Please input vehicleNo",
            vehicleProperty: "Please select vehicle property",
            vehicleTypeGb: "Please select vehicle type",
            terminalNo: "Please input terminalNo",
            terminalName: "Please input terminalName",
            terminalType: "Please select terminalType",
            bindingId: "Please select bindingObject",
            commids: "Please input commids",
            simNo: "Please input simNo"
        },
        message: {
            atLeastOneUser: "Select at least one user!",
            deleteUser: "Delete user?",
            deleteCarrier: "Delete carrier?"
        }
    }
};
